"use strict";

const axios = require("axios");
const qs = require("qs");
const Swal = require("sweetalert2");

class APIRequest {
  constructor() {}

  static async get_with_request(base_url, ressource, request, headers = {}) {
    let objects;
    let rows;
    await axios({
      method: "get",
      url: base_url + ressource + "/" + request,
      headers,
    })
      .then((response) => {
        objects = response.data.results;
        rows = response.data.count;
      })
      .catch((error) => {
        console.log(error);
      });
    return [objects, rows];
  }

  static async get_object_with_request(base_url, ressource, request) {
    let object;
    await axios({
      method: "get",
      url: base_url + ressource + "/" + request,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async list(base_url, ressource) {
    let objects;
    await axios({
      method: "get",
      url: base_url + ressource + "/",
    })
      .then((response) => {
        objects = response.data.results;
      })
      .catch((error) => {
        console.log(error);
      });
    return objects;
  }

  static async get_by_id(base_url, ressource, id, headers = {}) {
    let object;
    await axios({
      method: "get",
      url: base_url + ressource + "/" + id,
      headers,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async create(base_url, ressource, datas, request = "") {
    let object;
    await axios({
      method: "post",
      url: base_url + ressource + "/" + request,
      data: datas,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async create_with_params(base_url, ressource, datas, params) {
    let object;
    await axios({
      method: "post",
      url: base_url + ressource + "/" + params,
      data: datas,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async delete(base_url, ressource, id) {
    await axios({
      method: "delete",
      url: base_url + ressource + "/" + id,
    })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  }

  static async edit(base_url, ressource, id, datas) {
    let object;
    await axios({
      method: "put",
      url: base_url + ressource + "/" + id + "/",
      data: datas,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async edit_with_params(base_url, ressource, id, datas, params) {
    let object;
    await axios({
      method: "put",
      url: base_url + ressource + "/" + id + "/" + params,
      data: datas,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async patch(base_url, ressource, id, datas) {
    for (let key in datas) {
      if (datas[key] === null) {
        delete datas[key];
      }
      if (typeof datas[key] === "string") {
        if (datas[key].includes(".s3.amazonaws.com/media/private/")) {
          delete datas[key];
        }
      }
    }
    let object;
    await axios({
      method: "patch",
      url: base_url + ressource + "/" + id + "/",
      data: datas,
    })
      .then((response) => {
        object = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return object;
  }

  static async get_client_object(company_slug) {
    let client_object;
    console.log(company_slug);
    console.log(
      process.env.VUE_APP_API + "get_applications/?company_slug=" + company_slug
    );
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_API +
        "get_applications?company_slug=" +
        company_slug,
    })
      .then((response) => {
        client_object = response.data;
        console.log("client object :", response);
      })
      .catch((error) => {
        console.log(error);
      });
    return client_object;
  }

  static async get_client_token(client_object) {
    let access_token;
    await axios({
      method: "post",
      url: process.env.VUE_APP_AUTHDOMAIN,
      data: qs.stringify({
        client_id: client_object.client_id,
        client_secret: client_object.client_secret,
        grant_type: "client_credentials",
      }),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    })
      .then((response) => {
        access_token = response.data.access_token;
      })
      .catch((error) => {
        console.log(error);
      });
    return access_token;
  }

  static async get_company_token(company_slug) {
    let client_object, access_token;
    client_object = await this.get_client_object(company_slug);
    access_token = await this.get_client_token(client_object);
    return access_token;
  }
}

class FunctionHelpers {
  static async search(base_url, ressource, input, fields, text_array) {
    let request = `?fields=${fields}&search=${input}`;
    console.log(request);
    let request_result = await APIRequest.get_with_request(
      base_url,
      ressource,
      request
    );
    request_result = request_result[0];
    let return_array = [];
    for (let i = 0; i < request_result.length; i++) {
      let text = "";
      for (let j = 0; j < text_array.length; j++) {
        text += request_result[i][text_array[j]] + " ";
      }
      let object = {
        id: request_result[i].id,
        text: text,
      };
      return_array.push(object);
    }
    return return_array;
  }

  static formatSearchArray(
    searchArray,
    initialArray,
    lookingForInSearch,
    lookingForInInitial
  ) {
    let formatedSearch = [];
    for (let i = 0; i < searchArray.length; i++) {
      let findResult = initialArray.find(
        (user) =>
          user[lookingForInInitial] === searchArray[i][lookingForInSearch]
      );
      if (!findResult) {
        formatedSearch.push(searchArray[i]);
      }
    }
    return formatedSearch;
  }

  static formatUsers(users, userNeedFormat) {
    let formatedUsers = [];
    for (let i = 0; i < userNeedFormat.length; i++) {
      for (let j = 0; j < users.length; j++) {
        if (userNeedFormat[i] === users[j].uuid) {
          let object = {
            id: users[j].uuid,
            firstName: users[j].first_name,
            lastName: users[j].last_name,
          };
          formatedUsers.push(object);
        }
      }
    }
    return formatedUsers;
  }

  static formatTeams(teams, entity) {
    let formatedUsers = [];
    for (let i = 0; i < teams.length; i++) {
      let object = {
        id: teams[i][`${entity}_user`],
        firstName: teams[i][`${entity}_user_object`].first_name,
        lastName: teams[i][`${entity}_user_object`].last_name,
      };
      formatedUsers.push(object);
    }
    return formatedUsers;
  }

  static formatModelSelect(array, textFields, valueField) {
    let result = [];
    for (let i = 0; i < array.length; i++) {
      let text = "";
      for (let j = 0; j < textFields.length; j++) {
        text = text + array[i][textFields[j]] + " ";
      }
      let object = {
        text: text,
        value: array[i][valueField],
      };
      result.push(object);
    }
    return result;
  }

  static async confirmModal(action_name) {
    return await Swal.fire({
      title: "Êtes-vous sûr de vouloir effectuer cette action",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f46a6a",
      cancelButtonColor: "#34c38f",
      cancelButtonText: "Annuler",
      confirmButtonText: action_name,
    });
  }

  static async confirmModalSuccess(action_name) {
    return await Swal.fire({
      title: "Êtes-vous sûr de vouloir effectuer cette action",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#9b9b9b",
      cancelButtonText: "Annuler",
      confirmButtonText: action_name,
    });
  }

  static formErrorModal(
    message = "Certains de vos formulaires ne respectent pas les modalités"
  ) {
    Swal.fire("Attention", message, "warning");
  }

  static async customModal(
    action_name,
    message,
    confirmButtonColor = "#f46a6a",
    cancelButtonColor = "#34c38f",
    cancelButtonText = "Annuler",
    description = ""
  ) {
    return await Swal.fire({
      title: message,
      text: description,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: cancelButtonColor,
      cancelButtonText: cancelButtonText,
      confirmButtonText: action_name,
    });
  }

  static formatRequest(
    formFilters,
    activeFilters,
    page = 1,
    searchInput = "",
    pageSize = 30
  ) {
    let request = `?page_size=${pageSize}&page=${page}`;
    if (searchInput) {
      request += "&search=" + searchInput;
    }
    for (let key in formFilters) {
      if (
        formFilters[key] !== null &&
        formFilters[key] !== "" &&
        activeFilters[key]
      ) {
        request += `&${key}=${formFilters[key]}`;
      }
    }
    return request;
  }

  static createRequestParams(
    formFilters,
    activeFilters,
    page = 1,
    search = "",
    pageSize = 30
  ) {
    let activeFormFilters = {};
    console.log(formFilters);
    console.log(activeFilters);
    if (formFilters && activeFilters)
      activeFormFilters = Object.entries(formFilters).reduce(
        (acc, [key, value]) => {
          if (activeFilters[key]) {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );
    console.log(activeFormFilters);
    return {
      page,
      page_size: pageSize,
      search,
      ...activeFormFilters,
    };
  }

  static formatCalendarEvents(
    events,
    title,
    classNames,
    list,
    baseUrl,
    ressource
  ) {
    let formatedEvents = [];
    for (let i = 0; i < events.length; i++) {
      let event = {
        id: events[i].id,
        title: title,
        start: events[i].start,
        end: events[i].end,
        className: classNames,
        list: list,
        baseUrl: baseUrl,
        ressource: ressource,
      };
      formatedEvents.push(event);
    }
    return formatedEvents;
  }

  static getToastSuccessOptions(event) {
    return {
      message: event,
      type: "success",
      position: "top-right",
      duration: 6000,
      dismissible: true,
    };
  }

  static getMailSuccessOptions(event) {
    return {
      message: `Un mail a été envoyé ${event}`,
      type: "success",
      position: "top-right",
      duration: 6000,
      dismissible: true,
    };
  }
}

class Reporting {
  constructor() {}

  static getChartParams() {
    return {
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: [],
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      xaxis: {
        categories: [],
        title: {
          text: "Mois",
        },
      },
      legend: {
        show: false,
      },
    };
  }

  static getYAxisDataType() {
    return {
      total: [
        {
          title: {
            text: "Montant",
          },
        },
      ],
      count: [
        {
          title: {
            text: "Nombre",
          },
        },
      ],
    };
  }

  static formatRequestQuery(
    informations,
    dataType,
    formFilters,
    activeFilters
  ) {
    let finalQuery = `?data_type=${dataType}`;
    informations.forEach((information) => {
      if (information.value) {
        finalQuery = `${finalQuery}&${information.reference}=true`;
      }
    });
    for (let key in formFilters) {
      if (formFilters[key] !== null && activeFilters[key]) {
        finalQuery += `&${key}=${formFilters[key]}`;
      }
    }
    return finalQuery;
  }

  static formatColors(informations) {
    let colors = [];
    informations.forEach((information) => {
      if (information.value) {
        colors.push(information.color);
      }
    });
    return colors;
  }
}

module.exports.FunctionHelpers = FunctionHelpers;
module.exports.APIRequest = APIRequest;
module.exports.Reporting = Reporting;
